import { render, staticRenderFns } from "./ProfileAwards.vue?vue&type=template&id=9d472fd4&scoped=true&"
import script from "./ProfileAwards.vue?vue&type=script&lang=js&"
export * from "./ProfileAwards.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAwards.vue?vue&type=style&index=0&id=9d472fd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d472fd4",
  null
  
)

export default component.exports